import { render, staticRenderFns } from "./inputvselect.vue?vue&type=template&id=47fdb819&"
import script from "./inputvselect.vue?vue&type=script&lang=js&"
export * from "./inputvselect.vue?vue&type=script&lang=js&"
import style0 from "./inputvselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports